export default class Constants {
  public static apiKeyOData = '{782D5EC3-5E0C-4C01-BBFC-B3F8F34CC00D}';
  public static apiKeyJss = '{BBEC7EE2-E0B1-4041-90F4-80CA08BACE59}';

  public static Experiences = class {
    public static Ia = class {
      public static Advisors = 'iA Advisor Centre';
      public static Clients = 'iA My Client Space';
      public static Dealers = {
        UniFi: 'UniFi',
        Hyundai: 'Hyundai',
        Acura: 'Acura',
        Honda: 'Honda',
        Genesis: 'Genesis',
      };
      public static Partners = 'iA My Partner Space';
    };

    public static Investia = class {
      public static Advisors = 'Investia Advisor Centre';
      public static Clients = 'Investia My Client Space';
    };

    public static IaPrivateWealth = class {
      public static Clients = 'iA Securities My Client Space';
    };
  };
}
